import React, { useState } from "react";

const PaymentGateway = ({ onClose }) => {
  const [transactionId, setTransactionId] = useState("");
  const [screenshot, setScreenshot] = useState(null);

  const handleFileChange = (event) => {
    setScreenshot(event.target.files[0]);
  };

  const handleSubmit = (event) => {
    event.preventDefault();
    console.log("Transaction ID:", transactionId);
    console.log("Screenshot:", screenshot);
    onClose();
  };

  return (
    <div className="fixed inset-0 flex items-center justify-center bg-gray-900 bg-opacity-50">
      <div className="bg-white p-8 rounded-lg shadow-2xl w-full max-w-3xl border border-gray-300 flex">
        {/* Left Side */}
        <div className="w-1/2 p-6 flex flex-col items-center bg-gray-100 rounded-l-lg">
          <img
            src="https://cdni.iconscout.com/illustration/premium/thumb/payment-gateway-illustration-download-in-svg-png-gif-file-formats--bitcoin-logo-crypto-bank-method-cryptocurrency-and-blockchain-pack-science-technology-illustrations-3710638.png?f=webp"
            alt="Transaction Info"
            className="mb-4 w-full h-60 object-cover"
          />
          <p className="text-center text-gray-700 mb-4 font-semibold">
            Please enter your transaction details below.
          </p>
          <input
            type="text"
            placeholder="Transaction ID"
            value={transactionId}
            onChange={(e) => setTransactionId(e.target.value)}
            className="border p-3 rounded w-full mb-3 focus:ring-2 focus:ring-blue-400"
          />
          <input
            type="file"
            onChange={handleFileChange}
            className="border p-3 rounded w-full cursor-pointer focus:ring-2 focus:ring-blue-400"
          />
        </div>

        {/* Right Side */}
        <div className="w-1/2 p-6 flex flex-col items-center justify-between bg-gray-50 rounded-r-lg relative">
          <img
            src="https://i.pinimg.com/736x/a8/69/40/a86940a4ed8a69539b341f3c414c47b3.jpg"
            alt="QR Code"
            className="mb-4 w-full h-80 object-cover mt-7"
          />
          <button
            onClick={handleSubmit}
            className="bg-gradient-to-r from-blue-500 to-blue-700 text-white px-6 py-3 rounded-lg hover:from-blue-600 hover:to-blue-800 shadow-md transform transition-transform hover:scale-105 self-center"
          >
            Submit
          </button>
        </div>
      </div>
    </div>
  );
};

export default PaymentGateway;
